import store from '@/store/index'

const loading = {
  show () {
    store.commit('loading/show')
  },
  hide () {
    store.commit('loading/hide')
  },
}

export default loading
